// extracted by mini-css-extract-plugin
export default {"cookiesInfo":"Selection_cookiesInfo__1+9pE","cookiesData":"Selection_cookiesData__RJQdN","textSection":"Selection_textSection__LVJEe","cookieBox":"Selection_cookieBox__W2zTQ"};